// Fonction utilitaire pour générer une couleur basée sur un identifiant
export const getPseudoColor = (identifier: string): string => {
  let hash = 0;
  for (let i = 0; i < identifier.length; i++) {
    hash = identifier.charCodeAt(i) + ((hash << 5) - hash);
  }
  const hue = Math.abs(hash) % 360;
  return `hsl(${hue}, 70%, 50%)`;
};

// Configuration des statuts de vidéo avec leurs couleurs et labels
export const VIDEO_STATUS_CONFIG = {
  UPLOADING: { color: 'bg-yellow-500', label: 'Téléchargement' },
  PROCESSING: { color: 'bg-blue-500', label: 'Traitement' },
  READY: { color: 'bg-green-500', label: 'Prêt' },
  DISABLED: { color: 'bg-red-500', label: 'Désactivé' },
  OBSOLETE: { color: 'bg-gray-500', label: 'Obsolète' },
  FAILED: { color: 'bg-gray-400', label: 'Échec' }
} as const;

export type VideoStatus = keyof typeof VIDEO_STATUS_CONFIG;

// Fonction pour obtenir la configuration d'un statut
export const getVideoStatusConfig = (status: string) => {
  const config = VIDEO_STATUS_CONFIG[status as VideoStatus];
  return config || VIDEO_STATUS_CONFIG.FAILED;
};

// Fonction pour obtenir les classes CSS pour un statut
export const getVideoStatusClasses = (status: string) => {
  return getVideoStatusConfig(status).color;
};

// Fonction pour obtenir le label français d'un statut
export const getVideoStatusLabel = (status: string) => {
  return getVideoStatusConfig(status).label;
};

